import {
  $,
  $$,
  on,
  off,
  isClickOutside,
  toggleDetailsOpen,
} from "../../utils/dom";

import { customJsMedia } from "../../variables/mediaQueries.json";

const ACTIVE_CLASSNAME = "-visible";
const BODY_LOCK_CLASSNAME = "is-navOpen";
const MODAL_TOP_VAR = "--js-modal-top";

function navigation() {
  const nav = $(".js-navigation");
  const navItems = $$(".js-navigationItem");
  const navContents = $$(".js-navigationContent");
  const burger = $(".js-burger");
  const modal = $(".m-navigation__modal");
  const mediaQuery = matchMedia(customJsMedia["--tablet"]);

  const handleNavItemClick = (index: number) => (e: Event) => {
    const content = navContents?.[index];
    const clickedItem = e.currentTarget as HTMLButtonElement;
    if (clickedItem.classList.contains("-visible")) {
      // if click on nav-link again, close all and return.
      return closeAll();
    }

    // First close the old one
    closeAll();

    // Then open the clicked one
    clickedItem.classList.toggle(ACTIVE_CLASSNAME);
    content?.classList.toggle(ACTIVE_CLASSNAME);
    content?.setAttribute("open", "");

    // Set aria expanded
    clickedItem.setAttribute("aria-expanded", "true");

    /* on(clickedItem, "click", closeAll) */
    // Add clickOustide listener
    on(document, "click", handleDocumentClick);
  };

  const updateModalTop = () => {
    if (!nav || !modal) return;
    nav.style.setProperty(
      MODAL_TOP_VAR,
      `${modal.getBoundingClientRect().top}px`,
    );
  };

  const toggleMobileNav = () => {
    nav?.classList.toggle(ACTIVE_CLASSNAME);
    burger?.classList.toggle("-iconClose");
    const isOpen = nav?.classList.contains(ACTIVE_CLASSNAME) ?? false;
    document.body.classList.toggle(BODY_LOCK_CLASSNAME, isOpen);

    if (isOpen) {
      updateModalTop();
      window.addEventListener("resize", updateModalTop);
    } else {
      window.removeEventListener("resize", updateModalTop);
      nav?.style.removeProperty(MODAL_TOP_VAR);
    }
  };

  // If clicked outside, close all nav thingies + remove eventlistner
  const closeAll = () => {
    navItems?.forEach((item) => {
      item.classList.remove(ACTIVE_CLASSNAME);
      item.setAttribute("aria-expanded", "false");
    });

    navContents?.forEach((item) => {
      item.classList.remove(ACTIVE_CLASSNAME);
      item.removeAttribute("open");
    });

    nav?.classList.remove(ACTIVE_CLASSNAME);
    burger?.classList.remove("-iconClose");
    document.body.classList.remove(BODY_LOCK_CLASSNAME);
    window.removeEventListener("resize", updateModalTop);
    nav?.style.removeProperty(MODAL_TOP_VAR);

    off(document, "click", handleDocumentClick);
  };

  const handleDocumentClick = (e: Event) => {
    if (nav && isClickOutside(nav, e)) {
      closeAll();
    }
  };

  // Add eventlistener to all navitems + mobile nav icon
  navItems?.forEach((item, index) => {
    on(item, "click", handleNavItemClick(index), true);
  });
  on(burger, "click", toggleMobileNav);

  // Collapse dropdowns on mobile, expand on desktop. Also close all opened modals.
  const handleMatchMedia = (event: MediaQueryListEvent) => {
    toggleDetailsOpen(navContents, event.matches);
    closeAll();
  };
  mediaQuery.addEventListener("change", handleMatchMedia);
}

export const onContentLoaded = (): void => {
  navigation();
};

if (process.env.NODE_ENV !== "development") {
  document.addEventListener("DOMContentLoaded", onContentLoaded);
}
